import { SharedAssetsRequestAction } from 'types/api/sharedAssets/requests'

export type SharedAssetsRequestWithActionParams = {
  action: SharedAssetsRequestAction
  teamId: string
}

export const sharedAssetsQueryKeys = {
  get: (params: { teamId: string }) => ['sharedAssets', params] as const,
  getRequestsToMe: (params: { teamId: string }) =>
    ['sharedAssets/requests/toMe', params] as const
}

export const sharedAssetsMutationKeys = {
  postSharedAssetsRequests: (params: { teamId: string }) =>
    ['sharedAssets/requests', params] as const,
  postSharedAssetsRequestWithAction: ({
    action,
    ...params
  }: SharedAssetsRequestWithActionParams) => {
    return [`sharedAssets/requests/${action}`, params] as const
  }
}
